export default __webpack_public_path__ + "static/media/edit-icon.00a4da11.svg";